/** A return from Stripe Checkout, which the old plan step started. */
export function isCheckoutReturn(pathname: string, search: string): boolean {
  if (pathname.replace(/\/$/, "") !== "/onboarding/tier") return false;
  const params = new URLSearchParams(search);
  return params.has("session_id") || params.get("cancelled") === "true";
}
